if ($("body").hasClass("template-build-your-bundle")) {
  
  productarray = [];
  oldbydproducts = getCookie("bydproducts");
  
  if (oldbydproducts != null && oldbydproducts.length >= 1) {
    oldbydproducts = JSON.parse(oldbydproducts);
  }
  var date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
   var cselling_planid = 0;
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    async: false,
    success: function (cart) {
       if (cart.item_count !== 0) {
      cart.items.forEach(function (item, index) {
        if (Object.keys(item.properties).length > 0) {
           Object.entries(item.properties).forEach(([prkey, prvalue], prindex) => {
              if(prkey=='_dynamicBoxId'){
                var oproqty = item.quantity;
                cselling_planid = item.selling_plan_allocation.selling_plan.id;
                 if (oldbydproducts != null && oldbydproducts.length >= 1) {
                    Object.entries(oldbydproducts).forEach(([odpkey, odpvalue], odpindex) => {
                      if(odpvalue.variantid==item.id){
                         var oproqty = odpvalue.productqty;
                      }
                    });
                 }
                var currentproArray = {
                  variantid: item.id,
                  productimg: item.image,
                  producttitle: item.product_title,
                  productqty: oproqty,
                  productprice: item.presentment_price,
                };                
                if (productarray.length === 0) {
                  productarray.push(currentproArray);
                } else {
                  proexits = false;
                  Object.entries(productarray).forEach(([opkey, opvalue], opindex) => {
                    if (
                      parseInt(opvalue.variantid) ==
                      parseInt($(this).attr("data-variantid"))
                    ) {
                      opvalue.productqty = qty;
                      proexits = true;
                    }
                  });
                  if (proexits == false) {
                    productarray.push(currentproArray);
                  }
                }
              }
           });
          
        }
      });
          if(productarray != null){ 
            if (oldbydproducts != null && oldbydproducts.length >= 1) {
               Object.entries(oldbydproducts).forEach(([odpkey, odpvalue], odpindex) => {
                 var checkvarintid = odpvalue.variantid;
                 Object.entries(productarray).forEach(([opkey, opvalue], opindex) => {
                    if(opvalue!= checkvarintid){
                      productarray.push(odpvalue);
                    }
                 })
               })
            }
           //console.log("oldbydproductsssss", productarray);
            var bydproducts = JSON.stringify(productarray);
            
            document.cookie = "bydproducts="+bydproducts+"; expires=" + date.toGMTString() + "; path=/";     
            document.cookie = "bydsellingplan="+cselling_planid+"; expires=" + date.toGMTString() + "; path=/";
       }
       }
    },
  });
  oldbydproducts = getCookie("bydproducts");
  if (oldbydproducts != null && oldbydproducts.length >= 1) {
    oldbydproducts = JSON.parse(oldbydproducts);
  }
 //console.log('oldbydproducts',oldbydproducts);
  if (oldbydproducts != null && oldbydproducts.length >= 1) {
//    oldbydproducts = JSON.parse(oldbydproducts);
    var oldtotalqty = 0;
    var oldtotalprice = 0;
    var oldbydproduct = "";
    productarray = oldbydproducts;
    Object.entries(oldbydproducts).forEach(([odpkey, odpvalue], odpindex) => {
      oldbydproduct += `<div class="byo_product pro_${odpvalue.variantid}">
          <span class="byo_qty">${odpvalue.productqty}</span><span class="byo_remove" data-mprovid="${odpvalue.variantid}">x</span>
          <img src="${imgURL(odpvalue.productimg,"medium_crop_center")}" alt="${odpvalue.producttitle}">
          <p>${odpvalue.producttitle}</p>
      </div>`;

      oldtotalqty += Number(odpvalue.productqty);
      oldtotalprice +=
        Number(odpvalue.productqty) * Number(odpvalue.productprice);
    });
    $("#byo_selectedBundle").html(oldbydproduct);
  }

  minchooseproduct = maxchooseproduct = boxId = 0;

  const fetchDynamicBoxInformation = async (boxParentProductId) => {
    return new Promise((resolve, reject) => {
      fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
        method: "POST",
        body: JSON.stringify({
          productPlatformId: 7025097211939,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.ok)
            throw new Error(
              "Failed to get box"
            ); /*const { DynamicBox } = response;  resolve(DynamicBox);*/
            //console.log("fullresponse",response);
          // console.log("SKBYDresponseselectableProductVariants",response.DynamicBox.selectableProductVariants);
          // console.log("SKBYDresponsesettingsproductGrouping",response.DynamicBox.settings.productGrouping);
          // console.log("SKBYDresponsesettingsproductGroupingOrder",response.DynamicBox.settings.productGroupingOrder);
          let mainproductarray = [];
          minchooseproduct = response.DynamicBox.sizeRange[0];
          maxchooseproduct = response.DynamicBox.sizeRange[1];
          boxId = response.DynamicBox.boxId;
          if(!jQuery.isEmptyObject(response.DynamicBox.settings.productVariantGrouping)){
            Object.entries(
              response.DynamicBox.settings.productGroupingOrder
            ).forEach(([gokey, govalue], index) => {
              mainproductarray.push({ [govalue]: [] });
            });
            Object.entries(
              response.DynamicBox.settings.productVariantGrouping
            ).forEach(([gkey, value], index) => {
              //console.log("tgkey",gkey);
             // console.log("tvalue",value);
              var mproarrykey= value.title;
              //console.log("mproarrykey",mproarrykey);
              productVariantIds = value.productVariantIds;
              
              productVariantIds.forEach(variantid => {
                

                if (!jQuery.isEmptyObject(response.DynamicBox.selectableProductVariants)){
                Object.entries(response.DynamicBox.selectableProductVariants).forEach(([key, value], index) => {
                  sprovarnts = value.productVariants;
                    sprovarnts.forEach(element => {
                        if(element.id == variantid){
                            //console.log("matchvalue", value);
                                    Object.entries(mainproductarray).forEach(
                                      ([bkey, bvalue], bindex) => {
                                        //console.log('bkey',bkey);
                                        //console.log('bvalue',bvalue);
                                        Object.entries(bvalue).forEach(
                                          ([ckey, cvalue], cindex) => {
                                            if (ckey == mproarrykey) {
                                              bvalue[ckey].push(value);
                                            }
                                          }
                                        );
                                      }
                                    );
                        }
                    })
                })

              }


              });
              
            });
          // }  

          // if (
          //   !jQuery.isEmptyObject(response.DynamicBox.settings.productGrouping)
          // ) {
          //   Object.entries(
          //     response.DynamicBox.settings.productGroupingOrder
          //   ).forEach(([gokey, govalue], index) => {
          //     mainproductarray.push({ [govalue]: [] });
          //   });
          //   Object.entries(
          //     response.DynamicBox.settings.productGrouping
          //   ).forEach(([gkey, value], index) => {
              
          //     value.forEach(function (productid) {
          //       console.log("productid",productid);
          //       if (
          //         !jQuery.isEmptyObject(
          //           response.DynamicBox.selectableProductVariants
          //         )
          //       ) {
          //         Object.entries(
          //           response.DynamicBox.selectableProductVariants
          //         ).forEach(([key, value], index) => {
          //           if (
          //             value.productPlatformId.replace(
          //               "gid://shopify/Product/",
          //               ""
          //             ) == productid
          //           ) {
          //             Object.entries(mainproductarray).forEach(
          //               ([bkey, bvalue], bindex) => {
          //                 Object.entries(bvalue).forEach(
          //                   ([ckey, cvalue], cindex) => {
          //                     if (ckey == gkey) {
          //                       bvalue[ckey].push(value);
          //                     }
          //                   }
          //                 );
          //               }
          //             );
          //           }
          //         });
          //       }
          //     });
          //   });

             
            var productgroupgrid = "";
            Object.entries(mainproductarray).forEach(
              ([pkey, pvalue], pindex) => {
                Object.entries(pvalue).forEach(([pgkey, pgvalue], pgindex) => {
                  productgroupgrid += `<div class="pageSectionWrap byo_bundleWrap">
                <div class="headingholder">
                        <h2 class="h3">${pgkey}</h2>
                        <!--p>Elevate Your Shave Game</p-->
                    </div>
                <div class="gridrow_outer">
                    <div class="gridrow">`;

                  //console.log("pgvalue",pgvalue);
                   const uniqueItems = [...new Set(pgvalue)];
                   //console.log("pgvalue",uniqueItems);
                  Object.entries(uniqueItems).forEach(
                    ([pgvkey, pgvvalue], pgvindex) => {
                      //console.log('vssingle',pgvvalue);
                      //console.log('vssinglecountvariant',pgvvalue.productVariants.length);
                      countvariant = pgvvalue.productVariants.length;
                      var oldbydproduct = "";
                      var oldbydqty = 0;
                      var minusdisable = "disabled";
                      
                      var prohandle ='';
                      if(countvariant >=2){
                        pgvvalue.productVariants.forEach(function (item, index) {
                          if (oldbydproducts != null && oldbydproducts.length >= 1) {
                            Object.entries(oldbydproducts).forEach(
                            ([odpkey, odpvalue], odpindex) => {
                                    if (odpvalue.variantid == item.platformId.replace("gid://shopify/ProductVariant/","")) {
                                oldbydproduct = "select_byo";
                                oldbydqty = odpvalue.productqty;
                                minusdisable = "";
                              }
                            });
                          }  
                          productgroupgrid += byob_productgrid(
                          {
                            variantgid: item.platformId,
                            productHandle: pgvvalue.productHandle,
                            imageSrc: item.imageSrc,
                            productTitle: pgvvalue.productTitle,
                            productVariantTitle: item.productVariantTitle,
                            price: item.price,
                            oldbydproduct: oldbydproduct,
                            minusdisable: minusdisable,
                            oldbydqty: oldbydqty
                          }); 

                        });
                      }else{
                        if (oldbydproducts != null && oldbydproducts.length >= 1) {
                            Object.entries(oldbydproducts).forEach(
                            ([odpkey, odpvalue], odpindex) => {
                                    if (odpvalue.variantid == pgvvalue.productVariants[0].platformId.replace("gid://shopify/ProductVariant/","")) {
                                oldbydproduct = "select_byo";
                                oldbydqty = odpvalue.productqty;
                                minusdisable = "";
                              }
                            });
                          } 
                        productgroupgrid += byob_productgrid(
                          {
                            variantgid: pgvvalue.productVariants[0].platformId,
                            productHandle: pgvvalue.productHandle,
                            imageSrc: pgvvalue.productImageSrc,
                            productTitle: pgvvalue.productTitle,
                            productVariantTitle: pgvvalue.productVariants[0].productVariantTitle,
                            price: pgvvalue.productVariants[0].price,
                            oldbydproduct: oldbydproduct,
                            minusdisable: minusdisable,
                            oldbydqty: oldbydqty
                          });  
                                              
                      }
                      
                    }
                  );

                  productgroupgrid += `</div>
                </div>
              </div>`;
                });
              }
            );
            $(".allproducts").html(productgroupgrid);
            $(".byo_searchForm").removeClass("d-none");
            if (oldtotalqty >= maxchooseproduct) {
      document
        .querySelectorAll('[data-type="plus"]')
        .forEach(function (button) {
          button.disabled = true;
        });
    } else {
      document
        .querySelectorAll('[data-type="plus"]')
        .forEach(function (button) {
          button.disabled = false;
        });
    }
          }
          if (!jQuery.isEmptyObject(response.DynamicBox.sellingPlanGroup)) {
            //console.log('response.DynamicBox.sellingPlanGroup',response.DynamicBox.sellingPlanGroup);
            var dysellingplan = `<select class="selling_plan" id="selling_plan_new" name="dysellingplan" aria-label="Send Every">`;
            const orderedsellingplan = Object.keys(response.DynamicBox.sellingPlanGroup).sort().reduce(
              (obj, key) => { 
                obj[key] = response.DynamicBox.sellingPlanGroup[key]; 
                return obj;
              }, 
              {}
            );
            
            Object.entries(orderedsellingplan).forEach(
              ([plankey, planvalue], index) => {
                var oldbydsellingplan = getCookie("bydsellingplan");
                selected = "";
                if (
                  oldbydsellingplan != null &&
                  oldbydsellingplan.length >= 1 &&
                  oldbydsellingplan ==
                    plankey.replace("gid://shopify/SellingPlan/", "")
                ) {
                  selected = "selected";
                }
                Object.entries(planvalue).forEach(([key, value], index) => {
                  if (key == "title") {
                    //console.log(value);
                    dysellingplan += `<option ${selected} value="${plankey.replace(
                      "gid://shopify/SellingPlan/",
                      ""
                    )}">${value}</option>`;
                  }
                });
              }
            );
            dysellingplan += `</select>`;
            $(".byo_bundlePlan").html(dysellingplan);
          }

          if (!jQuery.isEmptyObject(response.DynamicBox.percentDiscountTier)) {
            var progressbar = "";
            Object.entries(response.DynamicBox.percentDiscountTier).forEach(
              ([key, value], index) => {
                progressbar += `<div class="byo_stepWrap">`;
                if (index == 0) {
                  progressbar += `<span class="byo_info">Min</span>`;
                }
                if (
                  index ===
                  Object.keys(response.DynamicBox.percentDiscountTier).length -
                    1
                ) {
                  progressbar += `<span class="byo_info">Max</span>`;
                }
                progressbar += `<div style="position: relative;"><div class="byo_circle">${key}</div><div class="byo_txt" data-discount="${value}">${value}% off</div></div>`;
                progressbar += `</div>`;
              }
            );
            $(".byo_progress").html(progressbar);
            $(".byo_stepWrap").each(function () {
              if (
                parseInt($(this).find(".byo_circle").text()) > parseInt(oldtotalqty)
              ) {
                $(this).removeClass("active_byo");
              } else {
                if(oldtotalqty> 0){
                $(this).addClass("active_byo");
                  }
              }
            });
            olddiscountpercent = $(".byo_stepWrap.active_byo:last")
              .find(".byo_txt")
              .attr("data-discount");
            olddiscountamount =
              oldtotalprice - oldtotalprice * (olddiscountpercent / 100);
            $(".totalitem").html(oldtotalqty);
            $(".byo_bundlePrice .productBox__price > span").html(
              theme.Currency.formatMoney(olddiscountamount * 100, theme.moneyFormat)
            );
            $(".byo_bundlePrice .productBox__price > del > span").html(
              theme.Currency.formatMoney(oldtotalprice * 100, theme.moneyFormat)
            );
            if(typeof olddiscountpercent !== "undefined"){
          $('.savedtag').html('Saved '+olddiscountpercent+'%');  
              $(".bydsubmit").prop("disabled", false);
          }else{
            $('.savedtag').html('');
              $(".bydsubmit").prop("disabled", true);
          }
            
          }
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  };

  fetchDynamicBoxInformation();

  function byob_productgrid({variantgid,productHandle,imageSrc,productTitle,productVariantTitle,price,oldbydproduct,minusdisable,oldbydqty}) {
    var fproductTitle = productTitle;
    if(productVariantTitle != 'Default Title'){
        fproductTitle = productTitle+' ('+productVariantTitle+')';
    }
return `<div class="column-6 column-sm-6 column-md-6 column-lg-4 column-xl-3 el">
    <div class="productBox__outer mainpro_${variantgid.replace(
      "gid://shopify/ProductVariant/",
      ""
    )}">
        <div class="productBox text-align-center d-flex flex-column h100 pb-3">
            <div class="productQuick_view open-popup byd_quickview" data-id="quickview_popup" data-bydquickview="yes" data-producthandle="${
              productHandle
            }">
                <?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px" y="0px" viewBox="0 0 474.2 318.6"
                    style="enable-background:new 0 0 474.2 318.6;" xml:space="preserve">
                    
                    <g>
                        <path class="st0"
                            d="M441.6,168.1c-41.3,74.2-119.7,120.3-204.4,120.3c-84.8,0-163.2-46.1-204.5-120.3c-3.2-5.8-3.2-11.9,0-17.6 C74,76.3,152.3,30.2,237.1,30.2c84.8,0,163.1,46.1,204.4,120.3C444.8,156.3,444.8,162.4,441.6,168.1L441.6,168.1z M468,135.8 C421.3,52,332.9,0,237.1,0C141.3,0,52.9,52,6.3,135.8c-8.3,14.9-8.3,32.1,0,47c46.6,83.8,135.1,135.8,230.9,135.8 c95.7,0,184.2-52,230.8-135.8C476.3,167.9,476.3,150.7,468,135.8L468,135.8z M237.1,221.3c34.2,0,62-27.8,62-62s-27.8-62-62-62 c-34.2,0-62.1,27.8-62.1,62S202.9,221.3,237.1,221.3z M237.1,67.1c-50.9,0-92.3,41.4-92.3,92.2c0,50.9,41.4,92.2,92.3,92.2 c50.9,0,92.2-41.4,92.2-92.2C329.4,108.4,288,67.1,237.1,67.1z" />
                    </g>
                </svg>
            </div>
            <div class="productBox__img ${oldbydproduct}">
                <div class="productBox__imgSlides">
                    <img loading="lazy"
                        src="${imageSrc}"
                        class="full_img d-block" alt="${fproductTitle}">
                </div>
            </div>

            <a href="#" class="d-block productBox__cntnt">
                <h3 class="h5 productBox__title mb-2">${fproductTitle}</h3>
                <!--p>Foaming Pre Shave Sugar Scrub</p-->
            </a>

            <div class="productBox__btnHolder">
                <div class="productBox__price mb-2 h6 price--on-sale">
                    <span class="money">$${
                      price
                    }</span>
                    <!--del class="price__sale">
                        <span class="money">$26.90</span>
                    </del-->
                </div>
                
            </div>

            <div class="qtydiv bundle-product-qty">
                <div class="qtyCalculator">
                    <button class="qtyBtns" data-type="minus"
                        data-variantid="${variantgid.replace(
                          "gid://shopify/ProductVariant/",
                          ""
                        )}" ${minusdisable}>-</button>
                    <input type="text" id="quantity" aria-label="Quantity" name="quantity" value="${oldbydqty}" min="0"
                        class="qtyInput" readonly="" data-variantid="${variantgid.replace(
                          "gid://shopify/ProductVariant/",
                          ""
                        )}"
                        pattern="[0-9]*" autocomplete="off" data-price="${
                          price
                        }">
                    <button class="qtyBtns" data-type="plus"
                        data-variantid="${variantgid.replace(
                          "gid://shopify/ProductVariant/",
                          ""
                        )}">+</button>
                </div>
            </div>
        </div>
    </div>
    <!-- end productBox__outer -->
</div>`;
}

  $(".byo_stickyBtn").click(function () {
    $(this).parents(".byo_stickyWrap").toggleClass("stickyActive");
  });

  $(document).on("click", ".qtyBtns", function () {

    oldbydproducts = getCookie("bydproducts");
  if (oldbydproducts != null && oldbydproducts.length >= 1) {
    productarray = JSON.parse(oldbydproducts);
  }
  

    
    var qty = parseInt(
      $(this).parents(".qtyCalculator").find(".qtyInput").val()
    );
    var act = $(this).data("type");
    if (qty > 9999) {
      var qty = 9999;
    }
    if (act == "plus") {
      if (qty < 9999) {
        qty++;
      }
    } else {
      if (qty >= 1) {
        qty--;
      }
    }
    qty = isNaN(qty) ? 0 : qty;
    $(this).parent(".qtyCalculator").find(".qtyInput").val(qty);

    if (qty > 0) {
      $(this)
        .parents(".productBox")
        .find(".productBox__img")
        .addClass("select_byo");
      if (
        !document.querySelectorAll(
          "#byo_selectedBundle .pro_" + $(this).attr("data-variantid")
        ).length > 0
      ) {
        $("#byo_selectedBundle").append(`<div class="byo_product pro_${$(
          this
        ).attr("data-variantid")}">
                            <span class="byo_qty">${qty}</span>
                            <span class="byo_remove" data-mprovid="${$(
                              this
                            ).attr("data-variantid")}">x</span>
                            <img src="${imgURL(
                              $(this)
                                .parents(".productBox")
                                .find(".productBox__img img")
                                .attr("src"),
                              "medium_crop_center"
                            )}" alt="${$(this).parents(".productBox").find(".productBox__title").text()}">
                            <p>${$(this)
                              .parents(".productBox")
                              .find(".productBox__title")
                              .text()}</p>
                        </div>`);
      }else{
        $("#byo_selectedBundle .pro_" + $(this).attr("data-variantid") +" .byo_qty").html(qty);
      }


      var currentproArray = {
        variantid: parseInt($(this).attr("data-variantid")),
        productimg: $(this)
          .parents(".productBox")
          .find(".productBox__img img")
          .attr("src"),
        producttitle: $(this)
          .parents(".productBox")
          .find(".productBox__title")
          .text(),
        productqty: qty,
        productprice: $(this)
          .parent(".qtyCalculator")
          .find(".qtyInput")
          .attr("data-price"),
      };
      if (productarray.length === 0) {
        productarray.push(currentproArray);
      } else {
        proexits = false;
        Object.entries(productarray).forEach(([opkey, opvalue], opindex) => {
          if (
            parseInt(opvalue.variantid) ==
            parseInt($(this).attr("data-variantid"))
          ) {
            opvalue.productqty = qty;
            proexits = true;
          }
        });
        if (proexits == false) {
          productarray.push(currentproArray);
        }
      }
    } else {
      $(this)
        .parents(".productBox")
        .find(".productBox__img")
        .removeClass("select_byo");
      $(".pro_" + $(this).attr("data-variantid")).remove();
      Object.entries(productarray).forEach(([opkey, opvalue], opindex) => {
        if (
          parseInt(opvalue.variantid) ==
          parseInt($(this).attr("data-variantid"))
        ) {
          const parindex = productarray.indexOf(opvalue);
          if (parindex > -1) {
            productarray.splice(parindex, 1); 
          }
        }
      });
    }

    //console.log("productarray", productarray);
    var bydproducts = JSON.stringify(productarray);
    document.cookie = "bydproducts="+bydproducts+"; expires=" + date.toGMTString() + "; path=/";

    var variantid = parseInt($(this).data("variantid"));
    if (typeof $(this).data("variantid") != "undefined") {
    }
    totalqty = 0;
    totalprice = 0;
    $("input.qtyInput").each(function () {
      totalqty += Number($(this).val());
      totalprice += Number($(this).val()) * Number($(this).attr("data-price"));
    });
    $(".byo_stepWrap").each(function () {
      
      if (parseInt($(this).find(".byo_circle").text()) > parseInt(totalqty)) {
        //console.log('byocif',$(this).find(".byo_circle").text());
      //console.log("totalqtyif",totalqty);
        $(this).removeClass('ssd').removeClass('active_byo');
      } else {
        //console.log('byocel',$(this).find(".byo_circle").text());
      //console.log("totalqtyel",totalqty);
        $(this).addClass('ssd').addClass('active_byo');
      }
    });

    if (totalqty >= maxchooseproduct) {
      document
        .querySelectorAll('[data-type="plus"]')
        .forEach(function (button) {
          button.disabled = true;
        });
    } else {
      document
        .querySelectorAll('[data-type="plus"]')
        .forEach(function (button) {
          button.disabled = false;
        });
    }

    if (totalqty >= minchooseproduct) {
      $(".bydsubmit").prop("disabled", false);
    } else {
      $(".bydsubmit").prop("disabled", true);
    }
    if (totalqty == 0) {
      $(this)
        .parent(".qtyCalculator")
        .find('[data-type="minus"]')
        .prop("disabled", true);
    } else {
      $(this)
        .parent(".qtyCalculator")
        .find('[data-type="minus"]')
        .prop("disabled", false);
    }

    // console.log("totalqty",totalqty);
    //console.log("totalprice",totalprice);
    let discountpercent = $(".byo_stepWrap.active_byo:last")
      .find(".byo_txt")
      .attr("data-discount");
    discountamount = totalprice - totalprice * (discountpercent / 100);
    //console.log('discountpercent',discountpercent);
    // console.log("discountamount",discountamount);
    $(".totalitem").html(totalqty);
    $(".byo_bundlePrice .productBox__price > span").html(
      theme.Currency.formatMoney(discountamount * 100, theme.moneyFormat)
    );
    $(".byo_bundlePrice .productBox__price > del > span").html(
      theme.Currency.formatMoney(totalprice * 100, theme.moneyFormat)
    );
    if(typeof discountpercent !== "undefined"){
    $('.savedtag').html('Saved '+discountpercent+'%');  
    }else{
      $('.savedtag').html('');
    }
    // show the bundle box in mobile
      if (window.matchMedia('(max-width: 991px)').matches) {    
        var byochildren = $('.byo_selectedBundle').children().length;
        $('.byo_stickyWrap').css('display', byochildren > 0 ? 'block' : 'none');
      }
    // show the bundle box in mobile end
    return false;
  
  });

  $(document).on("click", ".byo_remove", function () {
    mprovid = $(this).data("mprovid");
    $(".mainpro_" + mprovid + " .productBox__img").removeClass("select_byo");
    $(".mainpro_" + mprovid + " .qtyInput").val(0);
    $(this).parent().remove();
    
    totalqty = 0;
    totalprice = 0;
    $("input.qtyInput").each(function () {
      totalqty += Number($(this).val());
      totalprice += Number($(this).val()) * Number($(this).attr("data-price"));
    });

    $(".byo_stepWrap").each(function () {
      if (parseInt($(this).find(".byo_circle").text()) > parseInt(totalqty)) {
        $(this).removeClass("active_byo");
      } else {
        $(this).addClass("active_byo");
      }
    });

    if (totalqty == maxchooseproduct) {
      document
        .querySelectorAll('[data-type="plus"]')
        .forEach(function (button) {
          button.disabled = true;
        });
    } else {
      document
        .querySelectorAll('[data-type="plus"]')
        .forEach(function (button) {
          button.disabled = false;
        });
    }

    if (totalqty >= minchooseproduct) {
      $(".bydsubmit").prop("disabled", false);
    } else {
      $(".bydsubmit").prop("disabled", true);
    }
    // console.log("totalqty",totalqty);
    //console.log("totalprice",totalprice);
    let discountpercent = $(".byo_stepWrap.active_byo:last")
      .find(".byo_txt")
      .attr("data-discount");
    discountamount = totalprice - totalprice * (discountpercent / 100);
    // console.log("discountamount",discountamount);
    $(".totalitem").html(totalqty);
    $(".byo_bundlePrice .productBox__price > span").html(
      theme.Currency.formatMoney(discountamount * 100, theme.moneyFormat)
    );
    $(".byo_bundlePrice .productBox__price > del > span").html(
      theme.Currency.formatMoney(totalprice * 100, theme.moneyFormat)
    );
    if(typeof discountpercent !== "undefined"){
    $('.savedtag').html('Saved '+discountpercent+'%');  
    }else{
      $('.savedtag').html('');
    }
    oldbydproducts = getCookie("bydproducts");
    
    if (oldbydproducts != null && oldbydproducts.length>=1){
      //console.log("removecheckdkdkd",oldbydproducts);
      oldbydproducts = JSON.parse(oldbydproducts);
    Object.entries(oldbydproducts).forEach(([odpkey, odpvalue], odpindex) => {
      //console.log('odpvalue.variantid',odpvalue.variantid);
      //console.log('mprovid',mprovid);
        if(parseInt(odpvalue.variantid) == parseInt(mprovid)){
         // console.log('removearr',oldbydproducts);
            const parindex = oldbydproducts.indexOf(odpvalue);
            if (parindex > -1) { // only splice array when item is found
                oldbydproducts.splice(parindex, 1); // 2nd parameter means remove one item only
              }
        }
    });
     
    var bydproducts = JSON.stringify(oldbydproducts);
       
    document.cookie = "bydproducts="+bydproducts+"; expires=" + date.toGMTString() + "; path=/";
    }
    var bydallproducts = {};
    bydallproducts[mprovid] = 0;
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: { updates: bydallproducts },
      dataType: "json",
      success: function (stuff) {
      }
    });

    // show the bundle box in mobile
    if (window.matchMedia('(max-width: 991px)').matches) {    
      //console.log('working')
      var byochildren = $('.byo_selectedBundle').children().length;
      $('.byo_stickyWrap').css('display', byochildren > 0 ? 'block' : 'none');
      if(byochildren < 1){
        $('.byo_stickyWrap').removeClass("stickyActive");
      }
    }
    // show the bundle box in mobile end
  });

  $(document).on("change", "select[name='dysellingplan']", function () {
    // alert($(this).val());
    document.cookie = "bydsellingplan="+$(this).val()+"; expires=" + date.toGMTString() + "; path=/";
  });

  $(document).on("click", ".bydsubmit", function () {
    $(this).prop("disabled", true).html("Adding to Bag");
    var bydchooseproducts = [];
    var bydallproducts = {};
    $("input.qtyInput").each(function () {
      crqty = $(this).val();
      if (crqty > 0) {
        bydchooseproducts.push({
          quantity: crqty,
          id: $(this).data("variantid"),
          selling_plan: $("select[name='dysellingplan']").val(),
          properties: {
            _dynamicBoxIndex: 0,
            _dynamicBoxId: boxId,
          },
        });
      }
        bydallproducts[$(this).data("variantid")] = 0;
      
    });
    //console.log("bydchooseproducts", bydchooseproducts);
   // console.log("bydallproducts", bydallproducts);
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: { updates: bydallproducts },
      dataType: "json",
      success: function (stuff) {
        setTimeout(function () {
          $.ajax({
            url: "/cart/add.js",
            type: "POST",
            dataType: "json",
            data: { items: bydchooseproducts },
            success: function (result) {
              $(".bydsubmit").html("Added");
              document.cookie = 'bydproducts=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              document.cookie = 'bydsellingplan=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              document.location.href = "/cart";
            },
          });
        }, 1000);
      },
    });
  });

  var search = document.getElementById("byd_search");

  $("#byd_search").keydown(function (e) {
    if (e.which == 13) e.preventDefault();
  });
  search.addEventListener("keyup", function () {
    var els = document.querySelectorAll(".el");

    Array.prototype.forEach.call(els, function (el) {
      var values = search.value.toUpperCase().split(" ");
      var display = true;
      for (var i = 0; i < values.length; i++) {
        if (el.textContent.toUpperCase().trim().indexOf(values[i]) === -1)
          display = false;
      }
      el.style.display = display ? "block" : "none";
    });
    $(".byo_bundleWrap .gridrow").each(function () {
      if ($(this).children(":visible").length == 0) {
        $(this).parent().parent().addClass("nsresult");
      } else {
        $(this).parent().parent().removeClass("nsresult");
      }
    });
  });
  $(document).on("click", "#cancelsearch", function () {
    $('#byd_search').val('');
    var els = document.querySelectorAll(".el");
    Array.prototype.forEach.call(els, function (el) {
      el.style.display = "block";
    });
    $(".byo_bundleWrap .gridrow").each(function () {
       $(this).parent().parent().removeClass("nsresult");
    });    
});
}
// show the bundle box in mobile
if (window.matchMedia('(max-width: 991px)').matches) {    
  //console.log('working')
  var byochildren = $('.byo_selectedBundle').children().length;
  $('.byo_stickyWrap').css('display', byochildren > 0 ? 'block' : 'none');
}
// show the bundle box in mobile end